import {authentication} from "@/services/auth";
import {Device} from "@/services/Device";
import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "@/utils/utils";
import {responses} from "@/utils/responses";
import {errorHandler} from "@/services/errorHandler";

window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`

window.serverApi = `https://overflow.abc.co.zm/OnlineSalesServer/`
//window.serverApi = `http://self:8080/OnlineSalesServer/`
window.ticketApi = `https://lna.abc.co.zm/TicketApp/`


window.kazangApi = `https://realtime.abc.co.zm:8443/kazangApi/api/`
// window.kazangApi = `http://192.168.1.138:9333/kazangApi/api/`

window.gateWayApi = `https://lna.abc.co.zm/KazangPaymentGateway/api/GateWay/`
// window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`

window.franchiseTomcatApi = `https://overflow.abc.co.zm/Franchise_OnlineServer/`
//window.franchiseTomcatApi = `http://self:8080/Franchise_OnlineServer/`

window.printApi = `https://overflow.abc.co.zm/PrintApi/`

window.backOfficeTomcatApi = `https://overflow.abc.co.zm/Lyt-SoftBackOfficeApi/`
//window.backOfficeTomcatApi = `http://192.168.1.124:8282/Lyt-SoftBackOfficeApi/`

window.auth = authentication;
window.Device = Device;
window.responses = responses;
window.errorHandler = errorHandler
window.routeExceptions = ['login', 'forgot-password', 'kazangOnline', 'test-success', 'test-failed', 'initKazangOnline', 'signup', 'custom-install', 'custom-cart'];

const EventBus = new Vue()
window.EventBus = EventBus
window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

window.$utils = utils;  
Vue.prototype.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.currentDate = (dateString) => {
    let date = dateString ? new Date(dateString) : new Date();
    let d = date.toISOString().split('T')[0]
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let t = hour + ':' + minute + 'hrs';
    return `${d} ${t}`;
}
